import React from 'react';

import { useFoldableEntityTranslation } from './i18n';

function FoldableEntityEmpty(): React.JSX.Element {
  const { t } = useFoldableEntityTranslation();

  return <span className="BaseFoldableEntity__Empty">{t('empty')}</span>;
}

export { FoldableEntityEmpty };
